import React from 'react';

import '../Styles/OverviewTable.scss';

function OverviewTable({
  columns,
  data,
  renderCell,
  viewAllLink,
  wrapperClass,
}) {
  return (
    <div className={`overview-table  ${wrapperClass}`}>
      <table>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.label}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.length ? (
            data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col) => (
                  <td key={col.key}>
                    {renderCell
                      ? renderCell(col.key, row[col.key], row)
                      : row[col.key] ?? '—'}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length}>No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default OverviewTable;
